<template>
  <transition name="pl-fade">
    <div v-if="visible" class="pl-overlay" aria-live="polite" aria-busy="true">
      <div class="pl-box">
        <span class="pl-ring"></span>
        <izonay-picto class="pl-img" />
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import IzonayPicto from "./IzonayPicto.vue";

// Sayfalar arası geçişte veri yüklenirken gösterilen yükleniyor göstergesi.
// İstek ayarında silent: true verilirse (kendi durumunu ekranda gösteren istekler) gösterge çıkmaz.
// Bekleyen API isteği varsa (kısa istekler titremesin diye SHOW_DELAY sonra) görünür; en az MIN_VISIBLE kadar kalır.
const SHOW_DELAY = 200;
const MIN_VISIBLE = 350;

export default {
  name: "PageLoader",
  components: {
    IzonayPicto,
  },
  data() {
    return {
      pending: 0,
      visible: false,
    };
  },
  created() {
    this.showTimer = null;
    this.hideTimer = null;
    this.shownAt = 0;

    this.reqId = axios.interceptors.request.use(
      (config) => {
        if (!config.silent) {
          this.pending++;
          this.update();
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
    this.resId = axios.interceptors.response.use(
      (response) => {
        if (!response.config.silent) this.done();
        return response;
      },
      (error) => {
        if (!(error.config && error.config.silent)) this.done();
        return Promise.reject(error);
      }
    );
  },
  beforeDestroy() {
    axios.interceptors.request.eject(this.reqId);
    axios.interceptors.response.eject(this.resId);
    clearTimeout(this.showTimer);
    clearTimeout(this.hideTimer);
  },
  methods: {
    done() {
      this.pending = Math.max(0, this.pending - 1);
      this.update();
    },
    update() {
      if (this.pending > 0) {
        clearTimeout(this.hideTimer);
        if (!this.visible && !this.showTimer) {
          this.showTimer = setTimeout(() => {
            this.showTimer = null;
            if (this.pending > 0) {
              this.visible = true;
              this.shownAt = Date.now();
            }
          }, SHOW_DELAY);
        }
      } else {
        clearTimeout(this.showTimer);
        this.showTimer = null;
        if (this.visible) {
          var wait = Math.max(0, MIN_VISIBLE - (Date.now() - this.shownAt));
          clearTimeout(this.hideTimer);
          this.hideTimer = setTimeout(() => {
            if (this.pending === 0) this.visible = false;
          }, wait);
        }
      }
    },
  },
};
</script>

<style scoped>
.pl-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(248, 248, 248, 0.72);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}

.pl-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(9, 33, 84, 0.12);
}

.pl-ring {
  position: absolute;
  top: 6px;
  right: 6px;
  bottom: 6px;
  left: 6px;
  border-radius: 50%;
  border: 4px solid #FCE3CE;
  border-top-color: #F37615;
  border-right-color: #F37615;
  animation: pl-spin 1s linear infinite;
}

.pl-img {
  width: 36px;
  height: 36px;
}

.pl-fade-enter-active,
.pl-fade-leave-active {
  transition: opacity 0.2s ease;
}

.pl-fade-enter,
.pl-fade-leave-to {
  opacity: 0;
}

@keyframes pl-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
